export const logVar = (variable = { empty: undefined }) => {
  const varName = Object.keys(variable)[0]
  console.debug(varName, variable[varName])
}
